module.exports = __webpack_public_path__ + "img/perfect-icon.6398a935.png";